import {
    useGetDMaxCommon,
    type AboutDmaxInfoResponse,
    type AroundDmaxInfoResponse,
    type MainInfoDmaxResponse,
    type RoomDMaxInfoResponse,
    type SpecialDmaxInfoResponse,
} from "@/shared/server";
import { Center, Spinner, Text } from "@chakra-ui/react";
import { AboutSection, BackBanner, RoomPreview, SpecialPreview, TopSection, Travel } from "../common";

export const Home = () => {
    const { data: main } = useGetDMaxCommon<MainInfoDmaxResponse>({ section: "main" });
    const { data: about } = useGetDMaxCommon<AboutDmaxInfoResponse>({ section: "about" });
    const { data: room } = useGetDMaxCommon<RoomDMaxInfoResponse>({ section: "room" });
    const { data: around } = useGetDMaxCommon<AroundDmaxInfoResponse>({ section: "around" });
    const { data: special } = useGetDMaxCommon<SpecialDmaxInfoResponse>({ section: "special" });
    return main && about && special && around && room ? (
        <>
            <TopSection imgList={main.imgList} sector={main.sector} />
            <AboutSection about={about} />
            <RoomPreview room={room} />
            <BackBanner imgUrl={main.imgList[0]?.img_URL} />
            <SpecialPreview special={special} />
            {around.isUse && <Travel around={around} />}
        </>
    ) : (
        <Center h="100vh" columnGap="8px">
            <Text>LOADING</Text>
            <Spinner />
        </Center>
    );
};
